import ExtraUserInformation from './ExtraUserInformation';

export default ExtraUserInformation;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/index.js